import * as React from "react";
import {
  HomeRegular,
  HomeFilled,
  PersonFeedbackRegular,
  PersonFeedbackFilled,
  TextBulletListSquareRegular,
  TextBulletListSquareFilled,
  bundleIcon,
} from "@fluentui/react-icons";

import NavButton from "./NavButton";

import { PATHS } from "./routes/paths";

const HomeIcon = bundleIcon(HomeFilled, HomeRegular);
const FeedbackIcon = bundleIcon(PersonFeedbackFilled, PersonFeedbackRegular);
const DocsIcon = bundleIcon(TextBulletListSquareFilled, TextBulletListSquareRegular);

const NAV_ITEMS = [
  { key: "home", label: "Home", icon: <HomeIcon />, href: PATHS.HOME_PAGE },
  { key: "docs", label: "Docs", icon: <DocsIcon />, href: PATHS.DOCS_PAGE },
  { key: "feedback", label: "Feedback", icon: <FeedbackIcon />, href: PATHS.FEEDBACK_PAGE },
];

export default function Navbar() {
  return (
    <div className="flex items-center gap-[0.2rem] p-[2px] pt-[5px]">
      {NAV_ITEMS.map((item) => (
        <NavButton key={item.key} icon={item.icon} label={item.label} link={item.href} />
      ))}
    </div>
  );
}
